var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from "react";
import { ListHeader } from "../..";
import { tableHasAction } from "./utilsV2Table";
import { createUseStyles } from "react-jss";
import { classNames } from "../../utils/classNames";
import { TableHeaderCell } from "./TableHeaderCell";
import { rowValue } from "./sharedJSS";
import { useTableContext } from "../../hooks/useTableContext";
import { THEME } from "../../theming/theming";
import { SelectAllTableCheckbox } from "../SelectAllTableCheckbox";
import { SkeletonCheckbox } from "../SkeletonCheckbox";
export function V2TableHeader(props) {
    var _a, _b;
    var _c = useTableContext(), gridClassName = _c.gridClassName, isBulk = _c.isBulk, onSelectAll = _c.onSelectAll, tableTheme = _c.tableTheme;
    var sortColumn = props.sortColumn, sortDirection = props.sortDirection, onSort = props.onSort, headings = props.headings, id = props.id, styling = props.styling, dataId = props.dataId, dataTestId = props.dataTestId, data = props.data, form = props.form;
    var _d = useState(sortColumn), sortedColumnState = _d[0], setSortedColumnState = _d[1];
    var _e = useState(sortDirection !== null && sortDirection !== void 0 ? sortDirection : "desc"), sortedDirectionState = _e[0], setSortedDirectionState = _e[1];
    var handleSort = useCallback(function (headingKey) {
        var column = headingKey;
        var direction;
        if (sortedColumnState === headingKey) {
            direction = sortedDirectionState === "asc" ? "desc" : "asc";
        }
        else {
            direction = "asc";
        }
        if (onSort) {
            onSort(column, direction);
        }
        setSortedColumnState(column);
        setSortedDirectionState(direction);
    }, [
        sortedColumnState,
        sortedDirectionState,
        onSort,
        setSortedColumnState,
        setSortedDirectionState,
    ]);
    var classes = useTableHeaderClasses(tableTheme);
    var tableHasActions = tableHasAction(props);
    var tableHeadings = headings.map(function (heading, i) {
        return heading.sortable
            ? __assign(__assign({}, heading), { title: (React.createElement(TableHeaderCell, { title: heading.title, onSort: handleSort, sortColumn: sortedColumnState, sortDirection: sortedDirectionState, headingKey: heading.key })), className: classNames(classes.sortable, styling === "subdued" || (props === null || props === void 0 ? void 0 : props.childTable)
                    ? classes.subduedSortable
                    : classes.brandedSortable), id: id && "".concat(id, "__header-").concat(heading.key), dataField: "".concat(heading.key, "_").concat(i + 1) }) : __assign(__assign({}, heading), { dataField: "".concat(heading.key, "_").concat(i + 1) });
    });
    if (tableHasActions) {
        tableHeadings.push({ blank: true, title: "" });
    }
    return (React.createElement(ListHeader, { gridClassName: classNames(gridClassName, classes.rowValue), ariaRowIndex: 1, headings: tableHeadings, cellRole: "columnheader", rowRole: "row", className: classes.header, dataId: dataId && "".concat(dataId, "-header"), dataTestId: dataTestId && "".concat(dataTestId, "-header"), initialiseTabIndex: true, ariaSort: {
            column: sortedColumnState,
            direction: sortedDirectionState,
        }, contained: true, firstColumn: data &&
            form &&
            (form === null || form === void 0 ? void 0 : form.type) === "checkbox" && (React.createElement("div", { "aria-colindex": 1, role: "columnheader", key: 0 }, !((_a = props.form) === null || _a === void 0 ? void 0 : _a.values) || props.loading ? (React.createElement(SkeletonCheckbox, { className: classes.selectAll })) : (React.createElement(SelectAllTableCheckbox, { data: data, form: form, className: classes.selectAll, onChange: onSelectAll, invert: isBulk, dataTestId: dataTestId ? "".concat(dataTestId, "-select-all") : undefined, dataId: dataId ? "".concat(dataId, "-select-all") : undefined, totalDataLength: (_b = props.pagination) === null || _b === void 0 ? void 0 : _b.totalRecords })))) }));
}
function useTableHeaderClasses(_a) {
    var _b, _c, _d;
    var header = _a.header;
    var useStyles = createUseStyles({
        rowValue: rowValue,
        header: {
            borderBottom: header === null || header === void 0 ? void 0 : header.borderBottom,
            borderTop: header === null || header === void 0 ? void 0 : header.borderTop,
            backgroundColor: "".concat(header === null || header === void 0 ? void 0 : header.backgroundColor),
            padding: 0,
            transition: THEME.transitions.background,
            "& .list__header": {
                padding: 5,
                color: header === null || header === void 0 ? void 0 : header.color,
                fontWeight: (_b = header === null || header === void 0 ? void 0 : header.fontWeight) !== null && _b !== void 0 ? _b : 400,
                fontSize: (_c = header === null || header === void 0 ? void 0 : header.fontSize) !== null && _c !== void 0 ? _c : 14,
                textTransform: (_d = header === null || header === void 0 ? void 0 : header.textTransform) !== null && _d !== void 0 ? _d : "none",
                "&:not(:first-child)": {
                    borderLeft: header === null || header === void 0 ? void 0 : header.separator,
                },
            },
        },
        subduedSortable: {
            "&:hover": {
                backgroundColor: "#e0e7ed",
                cursor: "pointer",
            },
        },
        brandedSortable: {
            "&:hover": {
                backgroundColor: THEME.palette.primary.dark.color,
                cursor: "pointer",
            },
        },
        sortable: {
            transition: THEME.transitions.background,
            "&.list__header": {
                padding: 0,
            },
        },
        selectAll: {
            marginBottom: "0 !important",
            padding: [6, 9, 4, 9],
        },
    });
    return useStyles();
}
